import { LocationAttributeMappedLabel } from '../models';

export const LOCATION_ATTRIBUTE_LABEL_MAPPING: LocationAttributeMappedLabel[] = [
  { attributeKey: 'national_region', attributeLabel: 'National Region' },
  { attributeKey: 'name', attributeLabel: 'Site Name' },
  { attributeKey: 'region', attributeLabel: 'Region' },
];
